export default {
  icon: 'playlist_add_check',
  name: 'Journal des actions',
  noItems:
    "Il n'y a pas encore d'évènement en relation avec la demande d'intervention",
  fields: {
    description: 'Evènement',
    datetime: 'Date/Heure',
    origin: '1',
    origin_name: 'Origine',
    value: 'Valeur',
    recipient_lastname: 'DOE',
    recipient_firstname: 'John',
    recipient_activity: '1',
    recipient: 'Destinataire',
    recipient_activity_name: 'Technicien',
    recipient_employee_id: 'Matricule',
    phone_number: 'Numéro',
    recipient_exchange_type: 'SPH',
    recipient_exchange_type_name: "Type d'appareil",
    priority: 1,
    application_user: 'groupId',
    application_fullname: 'Auteur',
    comments: 'Commentaire',
  },
};
